import React from 'react';
import { ICarDetails } from '../../../../../../../../common/model/ICarDetails';
import { useSelector } from 'react-redux';
import carConfigurationSelectors from '../../../../../store/selectors/carConfigurationSelectors';
import { IPrice } from '../../../../../../../../common/model/IPrice';
import currentDealSelectors from '../../../../../store/selectors/currentDealSelectors';
import SummaryMinimal from './SummaryMinimal';
import { IFinanceQuote } from '../../../../../../common/model/IFinanceQuote';
import { usePersistedCurrencyPreference } from '../../../../../react/usePersistedCurrencyPreference';
import useToggleFinCalcSpc from '../../../../../../common/react/useToggleFinCalcSpc';
import stringUtilities from '../../../../../../../../common/utilities/stringUtilities';

const SummaryMinimalContainer = () => {
  const configuration: ICarDetails = useSelector(carConfigurationSelectors.getConfiguration);
  const isDataLoading = useSelector(currentDealSelectors.getLoadingStatus);

  const shouldRenderRates = Boolean(useSelector(currentDealSelectors.getFinanceQuoteComparisonRate));
  const shouldRenderTerm = Boolean(useSelector(currentDealSelectors.getFinanceQuoteDuration));
  const financeQuote: IFinanceQuote = useSelector(currentDealSelectors.getFinanceQuote);
  const secondaryCurrencyQuote: IFinanceQuote = useSelector(currentDealSelectors.getSecondaryCurrencyQuote);
  const carConfiguration = useSelector(carConfigurationSelectors.getConfiguration);
  const { toggleFinanceCalculatorSpc } = useToggleFinCalcSpc();
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();
  const isMultiCurrency = useSelector(currentDealSelectors.getIsMultiCurrency);
  const shouldDisplaySecondaryCurrency = isMultiCurrency && isSecondaryCurrencyDisplay;

  const primaryPrice: IPrice = useSelector(currentDealSelectors.getPrimaryPrice);
  const secondaryPrice: IPrice = useSelector(currentDealSelectors.getSecondaryPrice);
  const totalSecondary = useSelector(currentDealSelectors.getSecondaryPriceTotal);
  const totalPrimary = useSelector(currentDealSelectors.getPrimaryPriceTotal);
  const servicePlanPrice = useSelector(currentDealSelectors.getServicePlanPrice);

  const basePrice = shouldDisplaySecondaryCurrency ? secondaryPrice.basePrice : primaryPrice.basePrice;
  const monthlyPayment = shouldDisplaySecondaryCurrency
    ? secondaryCurrencyQuote?.monthlyPayment
    : financeQuote.monthlyPayment;
  const currency = shouldDisplaySecondaryCurrency ? secondaryPrice.currency : primaryPrice.currency;
  const total = shouldDisplaySecondaryCurrency
    ? // @TODO: Service plan addition in conflict with backend on with MLP price calc.
      totalSecondary.basePrice
    : (totalPrimary?.basePrice || null) + servicePlanPrice;
  const firstRegistrationTax = shouldDisplaySecondaryCurrency ? totalSecondary?.frt : totalPrimary?.frt;
  const selectionsPrice = total - basePrice - (firstRegistrationTax || 0);
  const sanitizedVariantTitle = stringUtilities.sanitizeVariantName(configuration.model.title, configuration.title);

  if (!configuration || !primaryPrice) {
    return null;
  }

  return (
    <SummaryMinimal
      loading={isDataLoading}
      currency={currency}
      basePrice={basePrice}
      monthlyPayment={monthlyPayment}
      selectionsPrice={selectionsPrice}
      firstRegistrationTax={firstRegistrationTax}
      totalWithServicePlan={total}
      modelTitle={configuration.model.title}
      variantTitle={sanitizedVariantTitle}
      shouldRenderRates={shouldRenderRates}
      shouldRenderTerm={shouldRenderTerm}
      financeQuote={financeQuote}
      carConfiguration={carConfiguration}
      toggleFinanceCalculatorSpc={toggleFinanceCalculatorSpc}
    />
  );
};

export default SummaryMinimalContainer;
